import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import ClarityHero from './ClarityHero';
import MirrorRooms from './MirrorRooms';
import TrustSection from './TrustSection';
import ClosingCta from './ClosingCta';
import Footer from './Footer';
import Seo from './Seo';
import { siteJsonLd } from '../seo/structuredData';
import { useI18n } from '../i18n/I18nContext';
import './MainPage.css';

function MainPage() {
  const { pathname } = useLocation();
  const { lang } = useI18n();

  return (
    <div className="michaela-main-page">
      <Seo
        page="home"
        noindex={pathname === '/welcome'}
        jsonLd={pathname === '/welcome' ? undefined : siteJsonLd(lang)}
      />

      <Header />
      <ClarityHero />
      <MirrorRooms />
      <TrustSection />
      <ClosingCta />

      <div id="contact">
        <Footer showContactForm={false} />
      </div>
    </div>
  );
}

export default MainPage;
